import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {HeaderService} from './header.service';

@Injectable()
export class SimcardService extends HeaderService {
    getSimCardsByFirm(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'getSimCardsByFirm/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    createSim(Sim: any): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'sim/',
            JSON.stringify(Sim),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    updateSim(Sim: any, id: String): Observable<any> {
        return this.http.put(environment.apiBaseUrl + 'sim/' + id,
            JSON.stringify(Sim),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getSimById(id: String): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'sim/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    deleteSim(_id: any): Observable<any> {
        return this.http.delete(environment.apiBaseUrl + 'sim/' + _id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
    
    getSimsForSuperAdmin(): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'sims-for-super-admin/',
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/simcard.service.ts